<script lang="ts">
	import Link from "@components/common/Link.svelte";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";

	const { breadcrumbs, currentPageTitle }: { breadcrumbs: Breadcrumb[]; currentPageTitle?: string } = $props();
</script>

{#if breadcrumbs.length > 0 && currentPageTitle}
	<nav class="container-center pt-6 pb-4 text-xs tracking-[2%] text-zms-optical-black md:block">
		{#each breadcrumbs as { label, href } (href)}
			<Link {href} class="hover:text-zms-blue font-semibold">
				{label}
			</Link>
			<span class="mx-1">/</span>
		{/each}
		<span class="text-gray-900 font-normal">{currentPageTitle}</span>
	</nav>
{/if}
